module.exports = __webpack_public_path__ + "img/Dantam Makeover 14.40f0b3e4.jpg";